export default "__VITE_ASSET__BSeHtJgv__"